import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home";
import Producten from "./views/Producten";
import Product from "./views/Product";
import About from "./views/About";
import Contact from "./views/Contact";
import Privacy from "./views/Privacy";
import Disclaimer from "./views/Disclaimer";
import Conditions from "./views/Conditions";


Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/about",
      name: "about",
      component: About
    },
    {
      path: "/contact",
      name: "contact",
      component: Contact
    },
    {
      path: "/producten/:categoryId/:categoryName",
      name: "producten",
      component: Producten,
      props: true
    },
    {
      path: "/producten",
      component: Producten,
      alias: "/producten/0"
    },
    {
      path: "/product/:productId/:productName",
      name: "product",
      component: Product,
      props: true
    },
    {
      path: "/privacy-policy",
      name: "privacy",
      component: Privacy
    },
    {
      path: "/disclaimer",
      name: "disclaimer",
      component: Disclaimer
    },
    {
      path: "/conditions",
      name: "conditions",
      component: Conditions
    }
  ]
});
